import { Action, any, IOWidget } from 'widgets-for-react'
import React from 'react'
import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { BlockData } from '../../cms/blocks/types.gen'
import { CustomBlockData, headerBlockData, imageTextBlockData, isCustomBlockData, moreStoriesBlockData, renderCustomBlock, textBlockData } from './custom_blocks/types.mod'
import { ExtraImages, getImageAttribute } from '../utils/extra_images.mod'
import { getMockedBlockRenderer, BlocksRenderer, renderBlock } from '../../cms/blocks/block_to_widget.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { TemplateState } from '../../cms/page/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { PublicSiteState } from '../../public_site.main.mod'
import { fromJSX, getRandomArbitrary } from '../../../utils'
import { AboutPage } from '../custom_pages/Fc150YearsWidget/components/AboutPage'
import { WordPress } from '../../wordpress/wordpress_api'


export let blocks_renderer = <customBlockData, extra_images, customPageData>() => ({
  ...getMockedBlockRenderer<customBlockData, extra_images, customPageData>()
})

export function pageDisplay_AUX(
  blocks: (Block | CustomBlock)[],
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>,
  public_state: PublicSiteState
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
> {
  return s => {

    const render_block = (b: CustomBlockData | BlockData<CustomBlockData, ExtraImages>, index: number) =>
      isCustomBlockData(b)
        ? renderCustomBlock(b, public_state, `key-${index}`)(s).map<
          Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
        >(a => s1 => {
          let res = a(s1)
          return { ...s1, images: res.images, blocks: res.blocks, custom_page_data: res.custom_page_data }
        })
        : renderBlock(b, blocks_renderer, `key-${index}`)(s).map<
          Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
        >(a => s1 => {
          let res = a(s1)
          return { ...s1, images: res.images, blocks: res.blocks }
        })

    let header = s.blocks.find(b => b.kind == 'headerBlock') as headerBlockData
    let textWithImages = s.blocks.filter(b => b.kind == 'imageTextBlock') as Immutable.Iterable<number, imageTextBlockData>

    if (s.page.kind == 'loaded' && s.page.value.extra_data.post.type == 'page' && (
      public_state.Fc150YearsMainPage.current_page == 'homepage' ||
      (
        public_state.Fc150YearsMainPage.current_page == 'transition-page' &&
        public_state.Fc150YearsMainPage.transition.animationState == 'wave-moving-down' &&
        public_state.Fc150YearsMainPage.transition.to.current_page == 'homepage'
      ) ||
      (
        public_state.Fc150YearsMainPage.current_page == 'transition-page' &&
        public_state.Fc150YearsMainPage.transition.animationState == 'wave-moving-up' &&
        public_state.Fc150YearsMainPage.transition.from.v.kind == "r" &&
        public_state.Fc150YearsMainPage.transition.from.v.v.current_page == 'homepage'
      ))) {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        fromJSX(setState => <main className="main main--home">
          <div className="main__inner">
            {/**render home header */}
            {header != undefined && render_block(header, s.blocks.keyOf(header)).run(a => setState(s2 => a(s2)))}

            <div className="home-theme__wrap">
              {/**Render text with images */}
              {textWithImages
                .map((b, index) => render_block(b, index))
                .valueSeq()
                .toArray()
                .map(widget => widget.run(a => setState(s2 => a(s2))))}

              <div className="portraits portraits--desktop">
                {
                  textWithImages.valueSeq().toArray().flatMap((twi, y) => twi.value.fst.images.map(
                    (img, i) => {
                      if (i % 3 == 0) {
                        return <div className="portrait portrait--small portrait--home top" data-parallax={getRandomArbitrary(75 - (y * 25), 200 - (y * 50))} key={`desktop-images-${y}-${i}`} >
                          <div className="portrait__inner">
                            {img && img?.source_url &&
                              <div className="portrait__visual">
                                <img className="portrait__image lazyload" width="300" height="300" alt=""
                                  src="/frontend/images/empty.png"
                                  data-src={getImageAttribute(img , 'portrait_s', 'source_url')}
                                  data-srcset={`${getImageAttribute(img , 'portrait_s', 'source_url')} 300w, ${getImageAttribute(img , 'portrait_l', 'source_url')} 600w`}
                                  data-sizes="auto"
                                />
                              </div>
                            }
                          </div>
                        </div>
                      } else if (i % 3 == 1) {
                        return <div className="portrait portrait--large portrait--home center" data-parallax={getRandomArbitrary(75 - (y * 25), 200 - (y * 50))} key={`desktop-images-${y}-${i}`} >
                          <div className="portrait__inner">
                            {img && img?.source_url &&
                              <div className="portrait__visual">
                                <img className="portrait__image lazyload" width="400" height="400" alt=""
                                  src="/frontend/images/empty.png"
                                  data-src={getImageAttribute(img , 'portrait_m', 'source_url')}
                                  data-srcset={`${getImageAttribute(img , 'portrait_m', 'source_url')} 400w, ${getImageAttribute(img , 'portrait_xl', 'source_url')} 800w`}
                                  data-sizes="auto"
                                />
                              </div>
                            }
                          </div>
                        </div>
                      }
                      return (
                        <>
                          <div className="portrait portrait--small portrait--home bottom" data-parallax={getRandomArbitrary(75 - (y * 25), 200 - (y * 50))} key={`desktop-images-${y}-${i}`} >
                            <div className="portrait__inner">
                              {img && img?.source_url &&
                                <div className="portrait__visual">
                                  <img className="portrait__image lazyload" width="300" height="300" alt=""
                                    src="/frontend/images/empty.png"
                                    data-src={getImageAttribute(img , 'portrait_s', 'source_url')}
                                    data-srcset={`${getImageAttribute(img , 'portrait_s', 'source_url')} 300w, ${getImageAttribute(img , 'portrait_l', 'source_url')} 600w`}
                                    data-sizes="auto"
                                  />
                                </div>
                              }
                            </div>
                          </div>

                          <div data-theme={twi.value.fst.taxonomy ? `theme--${twi.value.fst.taxonomy.slug}` : null} className="portraits__spacer" aria-hidden="true" />
                        </>
                      )
                    }
                  )
                  )
                }
              </div>
              <div className="home-theme__spacer" aria-hidden="true" />
            </div>

          </div>
        </main>),

      ])
    } else if (public_state.Fc150YearsMainPage.current_page == 'story-detail-page' ||
      (
        public_state.Fc150YearsMainPage.current_page == 'transition-page' &&
        public_state.Fc150YearsMainPage.transition.animationState == 'wave-moving-down' &&
        public_state.Fc150YearsMainPage.transition.to.current_page == 'story-detail-page'
      ) ||
      (
        public_state.Fc150YearsMainPage.current_page == 'transition-page' &&
        public_state.Fc150YearsMainPage.transition.animationState == 'wave-moving-up' &&
        public_state.Fc150YearsMainPage.transition.from.v.kind == "r" &&
        public_state.Fc150YearsMainPage.transition.from.v.v.current_page == 'story-detail-page'
      )
    ) {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        fromJSX(setState => {

          let story: WordPress.PageResponse & WordPress.EmbedData = undefined
          let taxonomy: WordPress.TaxonomyResponse = undefined
          if (public_state.Fc150YearsMainPage.state.page.page.kind == 'loaded') {
            story = public_state.Fc150YearsMainPage.state.page.page.value as unknown as WordPress.PageResponse & WordPress.EmbedData
            if (story != undefined && story._embedded != undefined && story._embedded['wp:term'] != undefined) {
              taxonomy = story._embedded['wp:term'].length > 0 ? story._embedded['wp:term'][0].length > 0 ? story._embedded['wp:term'][0][0] : undefined : undefined
            }
          }

          let moreStoriesBlock = s.blocks.find(b => b.kind == 'moreStoriesBlock') as moreStoriesBlockData

          return <>
            <main className="main main--story">
              <div className="main__inner">
                <article className={`page page--story theme--${taxonomy?.slug}`}>
                  <div className="page__inner">

                    {header != undefined && render_block(header, s.blocks.keyOf(header)).run(a => setState(s2 => a(s2)))}
                    <div className="page__content container--xl grid--gutter">
                      {header != undefined && <div className="page__aside aside">
                        <div className="aside__inner grid--spacing">
                          <h2 className="aside__title" dangerouslySetInnerHTML={{ __html: header?.value?.fst?.title }} />
                          <div className="aside__image portrait portrait--story portrait--large">
                            <div className="portrait__inner">
                              {header?.value?.fst?.image && header?.value?.fst?.image.source_url &&
                                <div className="portrait__visual">
                                  <img className="portrait__image lazyload" width="400" height="400" alt=""
                                    src="/frontend/images/empty.png"
                                    data-src={getImageAttribute(header?.value?.fst?.image, 'portrait_m', 'source_url')}
                                    data-srcset={`${getImageAttribute(header?.value?.fst?.image, 'portrait_m', 'source_url')} 400w, ${getImageAttribute(header?.value?.fst?.image, 'portrait_xl', 'source_url')} 800w`}
                                    data-sizes="auto"
                                  />
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>}

                      <div className="page__blocks">
                        {
                          s.blocks.filterNot(b => b.kind == 'headerBlock' || b.kind == 'moreStoriesBlock')
                            .toIndexedSeq().toArray()
                            .map((b, index) => render_block(b, index).run(a => setState(s2 => a(s2))))
                        }
                      </div>
                    </div>
                    {moreStoriesBlock && render_block(moreStoriesBlock, s.blocks.keyOf(moreStoriesBlock)).run(a => setState(s2 => a(s2)))}


                  </div>

                </article>
              </div>
            </main>
          </>
        })
      ])
    } else if (public_state.Fc150YearsMainPage.storiesOverviewState.isAbout || (
      public_state.Fc150YearsMainPage.current_page == 'transition-page' &&
      public_state.Fc150YearsMainPage.transition.animationState == 'wave-moving-down' &&
      public_state.Fc150YearsMainPage.storiesOverviewState.isAbout
    )) {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        fromJSX(_ => <AboutPage texts={public_state.Fc150YearsMainPage.state.page.blocks.filter(b => b.kind == 'textBlock').toIndexedSeq().toArray() as Array<textBlockData>} />)
      ])
    } else {
      return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
        ...s.blocks
          .map((b, index) => render_block(b, index))
          .valueSeq()
          .toArray()
      ])
    }

  }
}

export let pageDisplay = (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
): ((
  b: (Block | CustomBlock)[],
    public_state: PublicSiteState
) => IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
>) => (b, public_state) => pageDisplay_AUX(b, blocks_renderer, public_state)
